"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSubscriptionAlerts = void 0;
var React = __importStar(require("react"));
var IconSubscriptionAlerts = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M7.1201,15 L16.8801,15 C16.8081,14.743 16.7091,14.466 16.5841,14.277 C16.3901,13.986 15.9491,13.414 15.5931,12.95 C15.3701,12.66 15.1791,12.411 15.0931,12.29 C14.4561,11.396 14.4861,10.705 14.5131,10.094 C14.5271,9.771 14.5401,9.466 14.4511,9.127 C14.0711,7.696 13.2691,7 12.0001,7 C10.7301,7 9.9291,7.696 9.5491,9.128 C9.4601,9.466 9.4731,9.771 9.4871,10.094 C9.5141,10.705 9.5441,11.396 8.9071,12.29 C8.8211,12.411 8.6301,12.66 8.4071,12.95 C8.0511,13.414 7.6101,13.986 7.4161,14.277 C7.2911,14.466 7.1911,14.743 7.1201,15 Z M16.3861,12.341 C16.7571,12.823 17.2151,13.42 17.4161,13.723 C17.8261,14.339 17.9781,15.318 17.9951,15.428 C18.0161,15.571 17.9741,15.717 17.8781,15.827 C17.7831,15.937 17.6451,16 17.5001,16 L6.5001,16 C6.3541,16 6.2171,15.937 6.1221,15.827 C6.0261,15.717 5.9841,15.571 6.0051,15.428 C6.0211,15.318 6.1741,14.339 6.5841,13.723 C6.7851,13.42 7.2431,12.823 7.6141,12.341 C7.8271,12.063 8.0111,11.825 8.0931,11.71 C8.5301,11.096 8.5121,10.673 8.4881,10.138 C8.4721,9.772 8.4541,9.357 8.5821,8.873 C9.0481,7.118 10.0301,6.391 11.0001,6.13 L11.0001,6.111 C11.0001,5.591 11.3291,5.11 11.8081,5.018 C12.4391,4.896 12.9881,5.41 12.9881,6.059 L12.9891,6.126 C13.9631,6.385 14.9511,7.111 15.4181,8.872 C15.5461,9.357 15.5281,9.772 15.5121,10.138 C15.4881,10.673 15.4701,11.096 15.9071,11.71 C15.9891,11.825 16.1731,12.063 16.3861,12.341 Z M12,19 C10.896,19 10,18.104 10,17 L14,17 C14,18.104 13.104,19 12,19 Z M12,21 C16.963,21 21,16.962 21,12 C21,7.038 16.963,3 12,3 C7.037,3 3,7.038 3,12 C3,16.962 7.037,21 12,21 Z M12,2 C17.514,2 22,6.486 22,12 C22,17.514 17.514,22 12,22 C6.486,22 2,17.514 2,12 C2,6.486 6.486,2 12,2 Z" }))); };
exports.IconSubscriptionAlerts = IconSubscriptionAlerts;
exports.IconSubscriptionAlerts.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconSubscriptionAlerts;
